import type { HomeWidgetType } from './types';

export const MAX_HOME_WIDGETS = 6;

// New widget type? Also add its key to admin-frontend src/pages/HomeWidgetsOrder/constants.ts so admins can order it.
export const HOME_WIDGETS_PRIORITY: Record<HomeWidgetType, number> = {
  CrownRips: -2,
  Bingo: -1,
  Jackpot: -1,
  Coinback: 3,
  Message: 7,
  Offer: 6,
  RollingOffer: 6,
  Quest: 10,
  Tournament: 0,
  UnclaimedFreeSpin: 4,
  UpcomingDailyMission: 5,
  MetaGameEvent: 0,
  SnappyGift: 8,
  CrownRoad: 2,
  MonetizationEvent: 2,
  CashOffer: 6,
  Challenge: 1,
  // Ahead of coinback/offers, behind the tournament + metagame bucket: one headline liveops event
  // should not routinely displace another.
  SlotBattle: 1,
  UpcomingMission: 5,
  StampCard: 9,
};
